<template>
    <card-title class="h-o-card-recharge">
        <template slot="pre-body">
            <banner-selector
                v-if="!isCheckout"
                :show-tester-button="false"
                :show-referral="false"
                :show-promotion="false"
                event-label="banner_manual_recharge"
            />
        </template>

        <div v-if="!isRechargeSuccess">
            <div v-if="!isOrderRecharge && !isAmountRecharge && !isCheckout" class="row">
                <div class="col mb-4">
                    <router-link to="/payment/recharge" class="btn btn-success">
                        <i class="fas fa-arrow-left mr-1" aria-hidden="true"></i>
                        Voltar para a Recarga Automática
                    </router-link>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <!--<div v-if="isTesterPromotion" class="alert alert-primary" role="alert">
                        A promoção "Super Desconto" oferece até 60% de desconto na aquisição de pacotes promocionais
                        de recarga. Por exemplo, ao escolher o pacote de 36 meses, o valor mensal equivalente torna-se
                        60% menor em comparação ao preço mensal sem o pacote.
                    </div>-->

                    <div
                        class="form-group mb-4"
                        v-if="!isOrderRecharge && !isAmountRecharge && (isCheckout || user)"
                        v-show="showMonths && (monthlyCost > 0 || isCheckout)"
                    >
                        <label class="form-label mb-2">Período</label>

                        <div v-if="isCheckout || (user && user.isNPT)" class="btn-group-payment btn-group-payment-period">
                            <div class="btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 1 }" @click="onClickPeriod($event, 1)">
                                    <input type="radio" :value="1" autocomplete="off" v-model="recharge.period"> 1 mês
                                    <span class="badge badge-sm badge-secondary mb-0">Sem desconto</span>
                                </label>
                                <label
                                    v-for="period in discountPeriods"
                                    :key="period"
                                    class="btn btn-outline-primary"
                                    v-bind:class="{ active: recharge.period === period }"
                                    @click="onClickPeriod($event, period)"
                                >
                                    <input type="radio" :value="period" autocomplete="off" v-model="recharge.period"> {{ period }} meses
                                    <span class="badge badge-sm badge-success mb-0">{{ calcDiscount(period) }}% Desconto</span>
                                </label>
                            </div>
                        </div>

                        <div v-else class="btn-group-payment btn-group-payment-period">
                            <div class="btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 1 }" @click="onClickPeriod($event, 1)">
                                    <input type="radio" :value="1" autocomplete="off" v-model="recharge.period"> 1 mês
                                    <span class="badge badge-sm badge-secondary mb-0">Sem bônus</span>
                                </label>
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 6 }" @click="onClickPeriod($event, 6)">
                                    <input type="radio" :value="6" autocomplete="off" v-model="recharge.period"> 6 meses
                                    <span class="badge badge-sm badge-success mb-0">Bônus de 5%</span>
                                </label>
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 12 }" @click="onClickPeriod($event, 12)">
                                    <input type="radio" :value="12" autocomplete="off" v-model="recharge.period"> 12 meses
                                    <span class="badge badge-sm badge-success mb-0">Bônus de 10%</span>
                                </label>
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 24 }" @click="onClickPeriod($event, 24)">
                                    <input type="radio" :value="24" autocomplete="off" v-model="recharge.period"> 24 meses
                                    <span class="badge badge-sm badge-success mb-0">Bônus de 15%</span>
                                </label>
                                <label class="btn btn-outline-primary" v-bind:class="{ active: recharge.period === 36 }" @click="onClickPeriod($event, 36)">
                                    <input type="radio" :value="36" autocomplete="off" v-model="recharge.period"> 36 meses
                                    <span class="badge badge-sm badge-success mb-0">Bônus de 20%</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="!isOrderRecharge && !isAmountRecharge && !isCheckout"
                        v-show="showMonths && monthlyCost > 0"
                        class="mb-6"
                    >
                        <b-form-checkbox value="1" unchecked-value="0" v-model="isManualValue" @change="checkManualValue">
                            Inserir o valor de recarga manualmente
                        </b-form-checkbox>
                    </div>

                    <form-group label="Valor da recarga" label-for="rechargeAmount" :error="formErrors.amount">
                        <div class="row">
                            <div class="col-md-auto">
                                <div class="w-48">
                                    <div class="input-group input-group-amount">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text px-4">R$</span>
                                        </div>

                                        <money
                                            v-if="!isOrderRecharge"
                                            id="rechargeAmount"
                                            class="form-control text-right"
                                            placeholder="0"
                                            autocomplete="off"
                                            autofocus
                                            v-model="recharge.amount"
                                            v-bind="{decimal:',', thousands:'.', precision: (isCheckout ? 2 : 0), masked:false}"
                                            :disabled="isPeriodRecharge"
                                            @blur.native="_checkAmount"
                                            @keydown.native.stop.up="_increaseAmount"
                                            @keydown.native.stop.down="_decreaseAmount">
                                        </money>

                                        <div v-if="!isOrderRecharge && !isCheckout" class="input-group-append">
                                            <span class="input-group-text font-weight-normal border-0">,{{ formattedAmountDecimal }}</span>
                                        </div>

                                        <input
                                            v-if="isOrderRecharge"
                                            type="text"
                                            class="form-control text-right"
                                            readonly
                                            disabled
                                            v-model="formattedAmountWithoutDecimal">

                                        <div v-if="isOrderRecharge" class="input-group-append">
                                            <span class="input-group-text font-weight-normal border-0">,{{ formattedAmountDecimal }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md">
                                <div v-if="!isOrderRecharge">
                                    <div class="alert alert-secondary bg-transparent border-white px-0 mt-1 mb-0 d-none d-md-block">
                                        <div class="h6 mb-0">
                                            <span v-if="user && !user.isNPT && isPeriodRecharge">
                                                <strong>Bônus recebido:</strong> {{ bonusValue | formatMoney }}
                                            </span>
                                            <span v-else-if="(isCheckout || (user && user.isNPT && isPeriodRecharge)) && discountValue">
                                                <strong>Preço:</strong> <del class="text-muted">{{ noDiscountValue | formatMoney }}</del>
                                                <strong class="pl-2">Desconto:</strong> <span class="text-success">{{ discountValue | formatMoney }}</span>
                                            </span>
                                            <span v-else-if="showEstimateText">
                                                <strong>Duração estimada:</strong> {{ estimate }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="h6 text-secondary mb-6 d-md-none">
                                        <span v-if="user && !user.isNPT && isPeriodRecharge">
                                            <strong>Bônus extra:</strong> {{ bonusValue | formatMoney }}
                                        </span>
                                        <span v-if="user && user.isNPT && isPeriodRecharge && discountValue">
                                            <strong>Desconto:</strong> {{ discountValue | formatMoney }}
                                        </span>
                                        <span v-else-if="showEstimateText">
                                            <strong>Duração estimada:</strong> {{ estimate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form-group>
                </div>
            </div>

            <button
                v-if="!isOrderRecharge"
                v-show="!isPeriodRecharge && !hasCoupon"
                type="button"
                class="btn btn-link text-decoration-none p-0 mb-6"
                @click="hasCoupon = true"
            >
                <i class="fas fa-tags mr-1"></i> Possui um cupom promocional?
            </button>

            <form v-if="!isOrderRecharge" @submit.prevent="validateCoupon">
                <form-group v-show="!isPeriodRecharge && hasCoupon" label="Cupom promocional" label-for="rechargeCoupon" class="mb-4" :error="formErrors.coupon">
                    <div class="d-flex justify-content-start">
                        <input ref="rechargeCoupon" type="text" id="rechargeCoupon" class="form-control col-sm-6 col-md-4 col-lg-3" autocomplete="off" spellcheck="false" v-model="recharge.coupon" v-input-uppercase />
                        <button-form ref="btnValidateCoupon" type="submit" theme="success" class="btn-action ml-2" :disabled="isCouponEmpty">
                            Aplicar
                        </button-form>
                    </div>
                    <div class="valid-feedback" v-bind:class="{ 'd-block': couponMessage }">{{ couponMessage }}</div>
                </form-group>
            </form>

            <div class="form-group mb-6">
                <label class="form-label mb-2">Forma de pagamento</label>

                <div class="btn-group-payment btn-group-payment-method">
                    <div class="btn-group-toggle" data-toggle="buttons">
                        <label class="btn btn-outline-primary" v-bind:class="{ active: isCreditCard }">
                            <i class="icon far fa-credit-card"></i>
                            <input type="radio" value="CRD" autocomplete="off" v-model="recharge.payment"> Cartão
                        </label>
                        <label class="btn btn-outline-primary" v-bind:class="{ active: isPix }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" class="icon">
                                <g transform="translate(-714 -542.746)">
                                    <path d="M572.284,78.078a5.256,5.256,0,0,1-3.74-1.548l-5.4-5.4a1.026,1.026,0,0,0-1.419,0l-5.419,5.42a5.256,5.256,0,0,1-3.74,1.548H551.5l6.839,6.839a5.469,5.469,0,0,0,7.734,0l6.858-6.858Z" transform="translate(169.792 492.207)"/>
                                    <path d="M552.568,34.995a5.256,5.256,0,0,1,3.74,1.548l5.419,5.42a1,1,0,0,0,1.419,0l5.4-5.4a5.256,5.256,0,0,1,3.74-1.548h.65l-6.858-6.858a5.469,5.469,0,0,0-7.735,0L551.5,34.995Z" transform="translate(169.791 516.191)"/>
                                    <path d="M569.992,52.465l-4.144-4.144a.79.79,0,0,1-.294.059h-1.884a3.724,3.724,0,0,0-2.616,1.084l-5.4,5.4a2.595,2.595,0,0,1-3.665,0l-5.42-5.42a3.724,3.724,0,0,0-2.616-1.084h-2.317a.786.786,0,0,1-.278-.056L537.2,52.465a5.469,5.469,0,0,0,0,7.734l4.161,4.161a.787.787,0,0,1,.279-.056h2.317a3.724,3.724,0,0,0,2.616-1.084l5.419-5.419a2.654,2.654,0,0,1,3.666,0l5.4,5.4a3.724,3.724,0,0,0,2.616,1.084h1.884a.789.789,0,0,1,.294.059l4.144-4.144a5.469,5.469,0,0,0,0-7.734" transform="translate(178.406 504.414)"/>
                                </g>
                            </svg>
                            <input type="radio" value="PIX" autocomplete="off" v-model="recharge.payment"> PIX
                        </label>
                        <!--<label class="btn btn-outline-primary" v-bind:class="{ active: isMercadoPago }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36" class="icon">
                                <g>
                                    <path d="M25.984,36a39.055,39.055,0,0,1-10.733-1.412A26.365,26.365,0,0,1,7.06,30.735C2.507,27.456,0,22.939,0,18.015V17.006A12.055,12.055,0,0,1,2.04,10.4,18.721,18.721,0,0,1,7.605,4.989,33.855,33.855,0,0,1,25.984,0,33.93,33.93,0,0,1,44.391,4.989,18.718,18.718,0,0,1,49.96,10.4,12.051,12.051,0,0,1,52,17.006v1.009c0,4.933-2.5,9.45-7.029,12.719a26.263,26.263,0,0,1-8.2,3.853A39.38,39.38,0,0,1,25.984,36Zm.031-34.99A33.245,33.245,0,0,0,8.311,5.7C3.582,8.717.978,12.734.978,17.006s2.6,8.289,7.333,11.31A33.246,33.246,0,0,0,26.015,33c13.788,0,25.006-7.176,25.006-16S39.8,1.01,26.015,1.01Z"/>
                                    <path d="M256.116,1283.924a2.05,2.05,0,0,1-2.052-1.956c0-.095,0-.316-.221-.316a.287.287,0,0,0-.253.126,1.415,1.415,0,0,1-.979.442,2.255,2.255,0,0,1-.663-.126,1.512,1.512,0,0,1-1.137-1.609.276.276,0,0,0-.032-.221l-.095-.063h-.063a.449.449,0,0,0-.189.063,1.61,1.61,0,0,1-.979.347,1.792,1.792,0,0,1-.568-.094,2.094,2.094,0,0,1-1.326-2.461.266.266,0,0,0-.063-.221l-.126-.095-.095.095a1.579,1.579,0,0,1-1.958.221,1.562,1.562,0,0,1-.631-1.862,1.579,1.579,0,0,1,1.642-1.073,1.609,1.609,0,0,1,1.421,1.388l.063.41.221-.347a2.2,2.2,0,0,1,2.557-.915,1.633,1.633,0,0,1,1.1,1.514c.032.19.158.19.19.19a.191.191,0,0,0,.189-.095,1.621,1.621,0,0,1,1.168-.473,2.118,2.118,0,0,1,.884.189c1.484.631.821,2.556.789,2.556-.126.316-.126.473,0,.536l.063.032h.031a1.12,1.12,0,0,0,.316-.063,1.714,1.714,0,0,1,.789-.189,2.035,2.035,0,0,1,0,4.07Zm15.818-9.15c-2.463-2.145-8.177-7.1-9.724-8.266a6.349,6.349,0,0,0-1.989-1.167,3.741,3.741,0,0,0-1.01-.158,3.271,3.271,0,0,0-1.231.221,10.022,10.022,0,0,0-2.968,1.862l-.063.031a7.842,7.842,0,0,1-2.526,1.609,4.28,4.28,0,0,1-.916.095,2.311,2.311,0,0,1-1.768-.568c-.031-.032,0-.126.095-.252l.031-.032,2.147-2.335c1.7-1.7,3.315-3.313,7.009-3.376h.189a13.039,13.039,0,0,1,4.862,1.136,14.653,14.653,0,0,0,6.63,1.578,17.18,17.18,0,0,0,7.262-1.735c-.284-.221-.568-.473-.884-.694a15.951,15.951,0,0,1-6.378,1.451,13.966,13.966,0,0,1-6.188-1.483,14.05,14.05,0,0,0-5.3-1.262h-.221a9.234,9.234,0,0,0-6.03,2.146,12.287,12.287,0,0,0-3,.568,8.057,8.057,0,0,1-2.115.379h-.821a42.526,42.526,0,0,1-7.609-2.114c-.316.221-.6.442-.916.663a37.663,37.663,0,0,0,8.272,2.4c.347,0,.695.063,1.074.063a10.369,10.369,0,0,0,2.4-.442c.442-.126.979-.284,1.484-.379l-.41.41-2.21,2.4a1.1,1.1,0,0,0-.316,1.2,1.526,1.526,0,0,0,.6.663,4.6,4.6,0,0,0,2.336.6,4.288,4.288,0,0,0,.916-.095,8.776,8.776,0,0,0,2.936-1.8,9.575,9.575,0,0,1,2.873-1.735,3.367,3.367,0,0,1,.789-.095h.221a4.286,4.286,0,0,1,2.147,1.041c1.831,1.357,9.819,8.361,9.914,8.424a1.525,1.525,0,0,1,.474,1.2,1.271,1.271,0,0,1-.632,1.01,1.762,1.762,0,0,1-1.042.316,1.929,1.929,0,0,1-.947-.252c-.032-.032-2.778-2.556-3.789-3.376a.707.707,0,0,0-.474-.252.225.225,0,0,0-.189.095c-.158.189,0,.473.221.631l3.22,3.218a1.806,1.806,0,0,1,.442.884,1.477,1.477,0,0,1-.789,1.325,2.32,2.32,0,0,1-1.137.378,1.646,1.646,0,0,1-.916-.284l-.442-.442c-.852-.852-1.7-1.7-2.336-2.24a.939.939,0,0,0-.473-.221.456.456,0,0,0-.221.063.354.354,0,0,0,.063.473c.063.063.095.126.158.189l2.336,2.619a.861.861,0,0,1,.063,1.1l-.095.126a1.369,1.369,0,0,1-.221.189,1.827,1.827,0,0,1-1.136.379,1.182,1.182,0,0,1-.316-.032.8.8,0,0,1-.442-.189l-.031-.031c-.126-.126-1.326-1.325-2.273-2.146a.867.867,0,0,0-.474-.252.342.342,0,0,0-.221.094c-.189.221.095.536.221.663l2.021,2.177a.435.435,0,0,1-.095.126c-.063.126-.316.347-1.042.442a.615.615,0,0,1-.253.032,4.726,4.726,0,0,1-1.958-.6,2.857,2.857,0,0,0-.189-2.84,2.9,2.9,0,0,0-2.494-1.388h-.126a2.667,2.667,0,0,0-1.484-2.808,3.468,3.468,0,0,0-1.263-.252,2.24,2.24,0,0,0-.916.158,2.348,2.348,0,0,0-1.452-1.231,3.079,3.079,0,0,0-1.073-.189,2.763,2.763,0,0,0-1.642.536,2.533,2.533,0,0,0-3.757-.221c-.6-.473-3.063-2.051-9.661-3.534-.347-.063-1.073-.284-1.515-.41-.063.347-.126.725-.158,1.073,0,0,1.2.284,1.452.347,6.725,1.483,8.967,3.061,9.345,3.345a2.5,2.5,0,0,0,2.778,3.439,2.881,2.881,0,0,0,1.894,2.208,2.241,2.241,0,0,0,.916.158,1.745,1.745,0,0,0,.568-.063,2.892,2.892,0,0,0,2.557,1.672,2.3,2.3,0,0,0,.789-.126,2.948,2.948,0,0,0,4.862.946,6.016,6.016,0,0,0,2.526.757c.126,0,.253-.031.379-.031a2.251,2.251,0,0,0,1.7-.852.315.315,0,0,0,.126-.158,3.436,3.436,0,0,0,.789.126,2.627,2.627,0,0,0,1.642-.6,2.274,2.274,0,0,0,.947-1.388,3.44,3.44,0,0,0,.568.031,3.239,3.239,0,0,0,1.673-.505,2.552,2.552,0,0,0,1.2-2.177,1.481,1.481,0,0,0,.537.063,2.809,2.809,0,0,0,1.579-.473,2.264,2.264,0,0,0,1.073-1.767,2.367,2.367,0,0,0-.347-1.451,67.125,67.125,0,0,1,10.387-3.25c-.031-.347-.063-.726-.126-1.073A60.833,60.833,0,0,0,271.934,1274.774Z" transform="translate(-232.026 -1256.095)"/>
                                </g>
                            </svg>
                            <input type="radio" value="MPA" autocomplete="off" v-model="recharge.payment"> Mercado Pago
                        </label>-->
                        <!--<label class="btn btn-outline-primary" v-bind:class="{ active: isPicPay }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" class="icon">
                                <path d="M32.1,30.1H25.909v5.495H31.76c3.711,0,5.819,1.8,5.819,5.088,0,3.371-2.108,5.215-5.819,5.215H25.909v-10.3H19.38V59.633h6.53V51.391H32.1c7.506,0,11.807-4.073,11.807-10.942,0-6.532-4.3-10.351-11.807-10.351M47.88,36.739V23.633H61V36.739Zm2.186-2.185h8.743V25.818H50.066v8.737Zm2.186-2.185V28h4.372V32.37H52.252Z" transform="translate(-19.19 -23.633)" />
                            </svg>
                            <input type="radio" value="PIC" autocomplete="off" v-model="recharge.payment"> PicPay
                        </label>-->
                        <label v-if="!isCheckout" class="btn btn-outline-primary" v-bind:class="{ active: isBoleto }">
                            <i class="icon fas fa-barcode"></i>
                            <input type="radio" value="BOL" autocomplete="off" v-model="recharge.payment"> Boleto
                        </label>
                    </div>
                </div>
            </div>

            <form v-show="isBoleto" accept-charset="UTF-8" @submit.prevent="rechargeBoleto">
                <div class="alert alert-primary" role="alert">
                    O pagamento por boleto demora <span class="font-weight-bold">pelo menos 1 dia</span> para ser contabilizado quando
                    efetuado em dia útil e <span class="font-weight-bold">até 3 dias</span> quando pago em sábados, domingos
                    ou feriados. Isso pode pode ocasionar a desativação temporária dos seus serviços
                    por falta de créditos. Caso você precise de créditos com mais urgência, utilize
                    outras formas de pagamento.
                </div>

                <div class="alert alert-warning mb-5" role="alert">
                    A Hostoo não realiza a compensação manual de boletos através do envio de
                    comprovante de pagamento. A recarga será efetivada de forma automática após confirmação do gateway de
                    pagamentos.
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <form-group :error="formErrors.cpfCnpj">
                            <label class="form-label" for="boletoCpfCnpj">CPF / CNPJ</label>
                            <the-mask
                                type="tel"
                                id="boletoCpfCnpj"
                                class="form-control"
                                placeholder="000.000.000-00"
                                autocomplete="off"
                                :mask="['###.###.###-##', '##.###.###/####-##']"
                                v-model="recharge.cpfCnpj"></the-mask>
                        </form-group>
                    </div>
                </div>

                <form-group label="Nome completo / Razão social" label-for="boletoName" :error="formErrors.name">
                    <input type="text" id="boletoName" class="form-control" autocomplete="name" v-model="recharge.name" />
                </form-group>

                <div class="row">
                    <div class="col-md-6">
                        <form-group :error="formErrors.email">
                            <label class="form-label" for="boletoEmail">E-mail</label>
                            <input type="email" id="boletoEmail" class="form-control" autocomplete="email" v-model="recharge.email">
                        </form-group>
                    </div>
                    <div class="col-md-4">
                        <form-group :error="formErrors.phone">
                            <label class="form-label" for="boletoPhone">Telefone</label>
                            <the-mask
                                type="tel"
                                id="boletoPhone"
                                class="form-control"
                                placeholder="(00) 0000-0000"
                                autocomplete="tel-national"
                                :mask="['(##) ####-####', '(##) #####-####']"
                                v-model="recharge.phone"></the-mask>
                        </form-group>
                    </div>
                </div>                

                <div class="row mb-md-4">
                    <div class="col-md-3">
                        <form-group label="CEP" label-for="boletoAddressZip" class="mb-md-0" :error="formErrors.addressZip">
                            <zip-code id="boletoAddressZip" :disabled="isZipCodeDisabled" v-model="rechargeAddress.addressZip" @ready="cardUpdateAddress" @cancel="cardUpdateAddress" />
                        </form-group>
                    </div>
                    <div class="col-md-9">
                        <div class="row">
                            <div class="col-8 col-sm-9">
                                <form-group label="Endereço" label-for="boletoAddressStreet" class="mb-md-0" :error="formErrors.addressStreet">
                                    <input type="text" id="boletoAddressStreet" class="form-control" autocomplete="street-address" v-model="rechargeAddress.addressStreet">
                                </form-group>
                            </div>
                            <div class="col-4 col-sm-3">
                                <form-group label="Número" label-for="boletoAddressNumber" class="mb-md-0" :error="formErrors.addressNumber">
                                    <input type="text" id="boletoAddressNumber" class="form-control" v-model="rechargeAddress.addressNumber">
                                </form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <form-group label="Complemento" label-for="boletoAddressComplement" :error="formErrors.addressComplement">
                            <input type="text" id="boletoAddressComplement" class="form-control" v-model="rechargeAddress.addressComplement">
                        </form-group>
                    </div>
                    <div class="col-md-6">
                        <form-group label="Bairro" label-for="boletoAddressNeighborhood" :error="formErrors.addressNeighborhood">
                            <input type="text" id="boletoAddressNeighborhood" class="form-control" autocomplete="address-level3" v-model="rechargeAddress.addressNeighborhood">
                        </form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <form-group label="Cidade" label-for="boletoAddressCity" :error="formErrors.addressCity">
                            <input type="text" id="boletoAddressCity" class="form-control" autocomplete="address-level2"
                                   v-model="rechargeAddress.addressCity"
                                   v-bind:class="{ 'text-muted': disableCityStateFields }"
                                   :disabled="disableCityStateFields">
                        </form-group>
                    </div>
                    <div class="col-md-6">
                        <form-group label="Estado" label-for="boletoAddressState" :error="formErrors.addressState">
                            <b-select id="boletoAddressState" autocomplete="address-level1" :options="states" v-model="rechargeAddress.addressState" :disabled="disableCityStateFields"></b-select>
                        </form-group>
                    </div>
                </div>

                <form-group class="pt-6" :error="formErrors.terms">
                    <checkbox-terms v-model="recharge.terms" />
                </form-group>

                <div class="form-buttons">
                    <button-form ref="btnBoleto" type="submit" theme="success" class="btn-lg btn-block">
                        Gerar Boleto
                    </button-form>
                </div>
            </form>

            <form v-show="isCreditCard" accept-charset="UTF-8" @submit.prevent="rechargeCreditCard">
                <div class="card-title-subtitle pt-2">
                    <h5 class="card-title-inner">Dados do cartão de crédito</h5>
                </div>

                <form-group label="Número do cartão" label-for="cardNumber" :error="formErrors.cardNumber">
                    <the-mask
                        type="tel"
                        id="cardNumber"
                        class="form-control form-control-lg"
                        autocomplete="cc-number"
                        placeholder="0000 0000 0000 0000"
                        mask="#### #### #### ####"
                        v-model="recharge.cardNumber" />
                </form-group>

                <div class="row">
                    <div class="col-md-4 col-lg-6">
                        <form-group label="Nome impresso no cartão" label-for="cardName" :error="formErrors.cardName">
                            <input type="text" id="cardName" class="form-control" autocomplete="cc-name" v-model="recharge.cardName" v-input-uppercase>
                        </form-group>
                    </div>
                    <div class="col-md-4 col-lg-3">
                        <form-group label="Validade" label-for="cardExpiration" :error="formErrors.cardExpiration">
                            <input type="text" id="cardExpiration" class="form-control" autocomplete="cc-exp" placeholder="00/00" v-mask="'##/##'" v-model="recharge.cardExpiration">
                        </form-group>
                    </div>
                    <div class="col-md-4 col-lg-3">
                        <form-group label="Código de segurança" label-for="cardCode" :error="formErrors.cardCode">
                            <the-mask type="tel" id="cardCode" class="form-control" autocomplete="cc-csc" placeholder="000" v-model="recharge.cardCode" :mask="['###', '####']" />
                        </form-group>
                    </div>
                </div>

                <div class="card-title-subtitle">
                    <h5 class="card-title-inner">Dados do cliente</h5>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <form-group label="CPF / CNPJ" label-for="cardCpfCnpj" :error="formErrors.cpfCnpj">
                            <the-mask
                                type="tel"
                                id="cardCpfCnpj"
                                class="form-control"
                                placeholder="000.000.000-00"
                                autocomplete="off"
                                :mask="['###.###.###-##', '##.###.###/####-##']"
                                v-model="recharge.cpfCnpj"></the-mask>
                        </form-group>
                    </div>
                </div>

                <form-group label="Nome completo / Razão social" label-for="customerName" :error="formErrors.name">
                    <input type="text" id="customerName" class="form-control" autocomplete="name" v-model="recharge.name">
                </form-group>

                <div class="row">
                    <div class="col-md">
                        <form-group label="E-mail" label-for="cardEmail" :error="formErrors.email">
                            <input type="email" id="cardEmail" class="form-control" autocomplete="email" v-model="recharge.email">
                        </form-group>
                    </div>
                    <div class="col-md">
                        <form-group label="Telefone" label-for="cardPhone" :error="formErrors.phone">
                            <the-mask
                                type="tel"
                                id="cardPhone"
                                class="form-control"
                                autocomplete="tel-national"
                                placeholder="(00) 0000-0000"
                                :mask="['(##) ####-####', '(##) #####-####']"
                                v-model="recharge.phone" />
                        </form-group>
                    </div>
                    <div class="col-md">
                        <form-group label="Data de nascimento" label-for="cardBirthDate" :error="formErrors.cardBirthDate">
                            <input type="text" id="cardBirthDate" class="form-control" autocomplete="bday" placeholder="00/00/0000" v-mask="'##/##/####'" v-model="recharge.cardBirthDate">
                        </form-group>
                    </div>
                </div>

                <div class="card-title-subtitle">
                    <h5 class="card-title-inner">Endereço de cobrança</h5>
                </div>

                <div class="row mb-md-4">
                    <div class="col-md-3">
                        <form-group label="CEP" label-for="cardAddressZip" class="mb-md-0" :error="formErrors.addressZip">
                            <zip-code id="cardAddressZip" :disabled="isZipCodeDisabled" v-model="rechargeAddress.addressZip" @ready="cardUpdateAddress" @cancel="cardUpdateAddress" />
                        </form-group>
                    </div>
                    <div class="col-md-9">
                        <div class="row">
                            <div class="col-8 col-sm-9">
                                <form-group label="Endereço" label-for="cardAddressStreet" class="mb-md-0" :error="formErrors.addressStreet">
                                    <input type="text" id="cardAddressStreet" class="form-control" autocomplete="street-address" v-model="rechargeAddress.addressStreet">
                                </form-group>
                            </div>
                            <div class="col-4 col-sm-3">
                                <form-group label="Número" label-for="cardAddressNumber" class="mb-md-0" :error="formErrors.addressNumber">
                                    <input type="text" id="cardAddressNumber" class="form-control" v-model="rechargeAddress.addressNumber">
                                </form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <form-group label="Complemento" label-for="cardAddressComplement" :error="formErrors.addressComplement">
                            <input type="text" id="cardAddressComplement" class="form-control" v-model="rechargeAddress.addressComplement">
                        </form-group>
                    </div>
                    <div class="col-md-6">
                        <form-group label="Bairro" label-for="cardAddressNeighborhood" :error="formErrors.addressNeighborhood">
                            <input type="text" id="cardAddressNeighborhood" class="form-control" autocomplete="address-level3" v-model="rechargeAddress.addressNeighborhood">
                        </form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <form-group label="Cidade" label-for="cardAddressCity" :error="formErrors.addressCity">
                            <input
                                type="text"
                                id="cardAddressCity"
                                class="form-control"
                                autocomplete="address-level2"
                                v-model="rechargeAddress.addressCity"
                                v-bind:class="{ 'text-muted': disableCityStateFields }"
                                :disabled="disableCityStateFields"
                            >
                        </form-group>
                    </div>
                    <div class="col-md-6">
                        <form-group label="Estado" label-for="cardAddressState" :error="formErrors.addressState">
                            <b-select id="cardAddressState" autocomplete="address-level1" :options="states" v-model="rechargeAddress.addressState" :disabled="disableCityStateFields"></b-select>
                        </form-group>
                    </div>
                </div>

                <form-group class="pt-6" :error="formErrors.terms">
                    <checkbox-terms v-model="recharge.terms" />
                </form-group>

                <div class="form-buttons">
                    <button-form ref="btnCreditCard" type="submit" theme="success" class="btn-lg btn-block">
                        {{ btnRechargeText }}
                    </button-form>
                </div>
            </form>

            <div v-show="isMercadoPago">
                <div class="alert alert-primary" role="alert">
                    Para fazer uma recarga com <a href="https://www.mercadopago.com.br/" target="_blank"><strong>Mercado Pago</strong></a>,
                    preencha os dados do comprador abaixo e clique no botão de recarregar. Na tela seguinte você será
                    redirecionado para uma página de pagamento do Mercado Pago. Basta concluir seu pagamento e
                    aguardar a aprovação.
                </div>

                <form @submit.prevent="rechargeMercadoPago">
                    <form-group label="Nome completo" label-for="mercadoPagoName" :error="formErrors.name">
                        <input type="text" id="mercadoPagoName" class="form-control" autocomplete="name" v-model="recharge.name">
                    </form-group>

                    <div class="row">
                        <div class="col-md-5">
                            <form-group label="CPF" label-for="mercadoPagoCpf" :error="formErrors.cpf">
                                <the-mask
                                    type="tel"
                                    id="mercadoPagoCpf"
                                    class="form-control"
                                    autocomplete="off"
                                    mask="###.###.###-##"
                                    placeholder="000.000.000-00"
                                    v-model="recharge.cpf" />
                            </form-group>
                        </div>
                        <div class="col-md-5">
                            <form-group label="Telefone" label-for="mercadoPagoPhone" :error="formErrors.phone">
                                <the-mask
                                    type="tel"
                                    id="mercadoPagoPhone"
                                    class="form-control"
                                    autocomplete="tel-national"
                                    placeholder="(00) 00000-0000"
                                    v-model="recharge.phone"
                                    :mask="['(##) ####-####', '(##) #####-####']" />
                            </form-group>
                        </div>
                    </div>

                    <form-group label="E-mail" label-for="mercadoPagoEmail" :error="formErrors.email">
                        <input type="email" id="mercadoPagoEmail" class="form-control" autocomplete="email" v-model="recharge.email">
                    </form-group>

                    <form-group class="pt-6" :error="formErrors.terms">
                        <checkbox-terms v-model="recharge.terms" />
                    </form-group>

                    <div class="form-buttons">
                        <button-form ref="btnMercadoPago" type="submit" theme="success" class="btn-lg btn-block">
                            Recarregar com Mercado Pago
                        </button-form>
                    </div>
                </form>
            </div>

            <div v-show="isPix || isPicPay">
                <div v-show="isPicPay" class="alert alert-primary mb-5" role="alert">
                    No pagamento com <a href="https://www.picpay.com/" target="_blank"><strong>PicPay</strong></a>,
                    após preencher os dados abaixo e clicar no botão de recarregar, você será redirecionado para uma tela do
                    PicPay onde poderá realizar o pagamento através do QR Code. Você também receberá uma notificação em seu
                    celular para levá-lo ao aplicativo.
                </div>

                <form accept-charset="UTF-8" @submit.prevent="onRecharge">
                    <div class="row">
                        <div class="col-md-4">
                            <form-group :error="formErrors.cpfCnpj">
                                <label class="form-label" for="rechargeCpfCnpj">CPF / CNPJ</label>
                                <the-mask
                                    type="tel"
                                    id="rechargeCpfCnpj"
                                    class="form-control"
                                    placeholder="000.000.000-00"
                                    autocomplete="off"
                                    :mask="['###.###.###-##', '##.###.###/####-##']"
                                    v-model="recharge.cpfCnpj">
                                </the-mask>
                            </form-group>
                        </div>
                    </div>

                    <form-group label="Nome completo / Razão social" label-for="rechargeName" :error="formErrors.name">
                        <input type="text" id="rechargeName" class="form-control" autocomplete="name" v-model="recharge.name">
                    </form-group>

                    <div class="row">
                        <div class="col-md-6">
                            <form-group label="E-mail" label-for="rechargeEmail" :error="formErrors.email">
                                <input type="email" id="rechargeEmail" class="form-control" autocomplete="email" v-model="recharge.email">
                            </form-group>
                        </div>
                        <div class="col-md-4">
                            <form-group label="Telefone" label-for="rechargePhone" :error="formErrors.phone">
                                <the-mask
                                    type="tel"
                                    id="rechargePhone"
                                    class="form-control"
                                    autocomplete="tel-national"
                                    placeholder="(00) 00000-0000"
                                    v-model="recharge.phone"
                                    :mask="['(##) ####-####', '(##) #####-####']">
                                </the-mask>
                            </form-group>
                        </div>
                    </div>

                    <form-address ref="groupAddress" v-model="rechargeAddress" :errors="formErrors" />

                    <form-group class="pt-6" :error="formErrors.terms">
                        <checkbox-terms v-model="recharge.terms" />
                    </form-group>

                    <div class="form-buttons">
                        <button-form ref="btnRecharge" type="submit" theme="success" class="btn-lg btn-block">
                            {{ btnRechargeText }}
                        </button-form>
                    </div>
                </form>
            </div>
        </div>

        <div v-else>
            <div v-if="isBoleto">
                <div class="alert alert-success" role="alert">
                    Seu boleto foi gerado com sucesso! Clique no botão abaixo para visualizá-lo e efetuar o pagamento.
                </div>

                <div class="alert alert-warning" role="alert">
                    A Hostoo não realiza a compensação manual de boletos através do envio de
                    comprovante de pagamento. A recarga será efetivada de forma automática após confirmação do gateway de
                    pagamentos.
                </div>

                <alert-emergency-credit v-if="emergencyCredit && !isOrderRecharge && !isAmountRecharge" />

                <div class="form-buttons">
                    <a :href="boletoRechargeLink" target="_blank" class="btn btn-success">Visualizar boleto</a>
                    <button type="button" class="btn btn-outline-secondary ml-2" @click="resetRecharge">Realizar nova recarga</button>
                </div>
            </div>

            <div v-if="isCreditCard">
                <alert-payment-status
                    :confirmed="isPaymentConfirmed"
                    :cancelled="isPaymentCancelled"
                />

                <div v-show="!isPaymentConfirmed && !isPaymentCancelled" class="alert alert-success" role="alert">
                    Sua solicitação de recarga está sendo processada e você poderá ver os créditos em sua conta após
                    aprovação. Este processo pode levar alguns minutos ou mais tempo a depender do status do seu cartão.
                    <hr>
                    Em caso de dúvida, entre em contato conosco através do nosso
                    <router-link to="/support/tickets">suporte</router-link>.
                </div>

                <div class="form-buttons">
                    <a v-if="isCheckout" href="/" class="btn btn-success">Acessar painel da Hostoo</a>
                    <button v-else type="button" class="btn btn-outline-secondary" @click="resetRecharge">Realizar nova recarga</button>
                </div>
            </div>

            <div v-if="isPix">
                <div class="alert alert-info" role="alert">
                    Utilize o aplicativo do seu banco para escanear o <strong>QR Code</strong> abaixo e concluir o pagamento.
                </div>

                <div class="mb-6">
                    <p class="mb-1"><strong>Valor:</strong> {{ this.recharge.amount | formatMoney }}</p>
                    <p class="mb-0"><strong>Expiração:</strong> {{ pixExpiration | moment("DD/MM/YYYY HH:mm:ss") }} (Horário de Brasília)</p>
                </div>

                <div class="mb-6">
                    <img class="img-thumbnail d-block mx-auto" v-bind:src="pixQrCode" alt="">
                </div>

                <div class="form-inline justify-content-center mb-4">
                    <label class="my-1 mr-2" for="pixCopyPaste">PIX Copia e Cola:</label>
                    <input type="text" ref="pixCopyPaste" id="pixCopyPaste" class="form-control col-lg-4 my-1 mr-sm-2" readonly v-model="pixCode">
                    <button type="button" class="btn btn-success my-1" @click="copyPixCode">Copiar</button>
                </div>

                <alert-payment-status
                    :confirmed="isPaymentConfirmed"
                    :cancelled="isPaymentCancelled"
                />

                <div v-show="!isPaymentConfirmed && !isPaymentCancelled" class="alert alert-info" role="alert">
                    Após realizar o pagamento, sua recarga será processada e você poderá ver os créditos em sua conta
                    dentro de alguns minutos.
                    <hr>
                    Em caso de dúvidas, entre em contato conosco através do nosso
                    <router-link to="/support/tickets">suporte</router-link>.
                </div>

                <div class="form-buttons">
                    <a v-if="isCheckout" href="/" class="btn btn-success">Acessar painel da Hostoo</a>
                    <button v-else type="button" class="btn btn-outline-secondary" @click="resetRecharge">Realizar nova recarga</button>
                </div>
            </div>

            <div v-if="isMercadoPago">
                <div class="alert alert-success" role="alert">
                    Agora <strong>clique no botão abaixo</strong> para ser redirecionado para uma tela do Mercado Pago
                    e conclua o seu pagamento.
                </div>

                <div class="form-buttons">
                    <a :href="mercadoPagoRechargeLink" class="btn btn-success">Ir para o Mercado Pago</a>
                    <button type="button" class="btn btn-outline-secondary ml-2" @click="resetRecharge">Realizar nova recarga</button>
                </div>
            </div>

            <div v-if="isPicPay">
                <div class="alert alert-success" role="alert">
                    Dentro de alguns segundos você será redirecionado para uma tela do PicPay onde poderá
                    concluir o pagamento.
                </div>

                <div class="form-buttons">
                    <a :href="picPayRechargeLink" class="btn btn-success">Ir para o PicPay</a>
                    <button type="button" class="btn btn-outline-secondary ml-2" @click="resetRecharge">Realizar nova recarga</button>
                </div>
            </div>
        </div>
    </card-title>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import { Money }            from 'v-money'
    import payment              from "@/mixins/payment";
    import ErrorService         from '@/services/error.service'
    import UserService          from '@/services/user.service'
    import CheckboxTerms        from '@/components/atoms/CheckboxTerms'
    import ButtonForm           from '@/components/atoms/ButtonForm'
    import AlertEmergencyCredit from '@/components/atoms/AlertEmergencyCredit'
    import ZipCode              from '@/components/atoms/ZipCode'
    import CardTitle            from '@/components/molecules/CardTitle'
    import FormGroup            from '@/components/molecules/FormGroup'
    import BannerSelector       from '@/components/organisms/BannerSelector'
    import FormAddress          from '@/components/organisms/FormAddress'
    import AlertPaymentStatus from "@/components/atoms/AlertPaymentStatus.vue";

    export default {
        mixins: [
            payment
        ],
        props: {
            email: {
                type: String,
                default: ""
            },
            order: {
                type: Number,
                default: null
            },
            amount: {
                type: Number,
                default: 50
            },
            period: {
                type: Number,
                default: 12
            },
            monthlyCost: {
                type: Number,
                default: null
            },
            showMonths: {
                type: Boolean,
                default: true
            },
            emergencyCredit: {
                type: Boolean,
                default: false
            },
            isCheckout: {
                type: Boolean,
                default: false
            }
        },
        components: {
            AlertPaymentStatus,
            BannerSelector,
            FormAddress,
            AlertEmergencyCredit,
            ZipCode,
            ButtonForm,
            Money,
            CardTitle,
            FormGroup,
            CheckboxTerms
        },
        data() {
            return {
                states: [
                    { value: null, text: "" },
                    { value: "AC", text: "Acre" },
                    { value: "AL", text: "Alagoas" },
                    { value: "AP", text: "Amapá" },
                    { value: "AM", text: "Amazonas" },
                    { value: "BA", text: "Bahia " },
                    { value: "CE", text: "Ceará" },
                    { value: "DF", text: "Distrito Federal " },
                    { value: "ES", text: "Espírito Santo" },
                    { value: "GO", text: "Goiás" },
                    { value: "MA", text: "Maranhão" },
                    { value: "MT", text: "Mato Grosso" },
                    { value: "MS", text: "Mato Grosso do Sul" },
                    { value: "MG", text: "Minas Gerais" },
                    { value: "PA", text: "Pará" },
                    { value: "PB", text: "Paraíba" },
                    { value: "PR", text: "Paraná" },
                    { value: "PE", text: "Pernambuco" },
                    { value: "PI", text: "Piauí" },
                    { value: "RJ", text: "Rio de Janeiro" },
                    { value: "RN", text: "Rio Grande do Norte" },
                    { value: "RS", text: "Rio Grande do Sul" },
                    { value: "RO", text: "Rondônia" },
                    { value: "RR", text: "Roraima" },
                    { value: "SC", text: "Santa Catarina" },
                    { value: "SP", text: "São Paulo" },
                    { value: "SE", text: "Sergipe" },
                    { value: "TO", text: "Tocantins" },
                ],

                userData: null,
                recharge: {
                    period  : 12,
                    payment : "CRD",
                    isCheckout: this.isCheckout,
                },
                rechargeAddress: {},
                isManualValue: "0",
                formErrors: {},

                pricing: null,
                discountPeriods: [],

                bonusPercent: {
                    1: 0,
                    6: 5,
                    12: 10,
                    24: 15,
                    36: 20,
                },

                // Address
                disableCityStateFields: false,

                // Cielo fingerprint
                fingerprint: "",

                // Google
                googleClientId: null,
                googleSessionId: null,

                // Coupon data
                hasCoupon: false,
                couponMessage: "",

                // Recharge links
                boletoRechargeLink: "",
                picPayRechargeLink: "",
                mercadoPagoRechargeLink: "",

                // Pix
                pixQrCode: "",
                pixCode: "",
                pixExpiration: "",

                // Flags
                isZipCodeDisabled: false,
                isRechargeSuccess: false,

                paymentInvoice: null,
                paymentState: null,
                isPaymentConfirmed: false,
                isPaymentCancelled: false,
            }
        },
        computed: {
            ...mapState('user', [
                'user',
                'promotion',
            ]),
            ...mapGetters('user', [
                'isTesterPromotion',
            ]),

            baseApiRoute: function () {
                return this.isCheckout ? '/checkout' : '/recharge';
            },

            minRecharge: function () {
                return 20;
            },
            isPeriodRecharge: function () {
                return this.recharge.period > 0 && this.monthlyCost > 0;
            },
            isOrderRecharge: function () {
                return this.order !== null;
            },
            isAmountRecharge: function () {
                return this.amount > 0 && !this.isOrderRecharge;
            },
            isCouponEmpty: function () {
                return (!this.recharge.coupon || (this.recharge.coupon.trim()).length === 0);
            },
            isBoleto: function () {
                return this.recharge.payment === 'BOL';
            },
            isCreditCard: function () {
                return this.recharge.payment === 'CRD';
            },
            isPix: function () {
                return this.recharge.payment === 'PIX';
            },
            isMercadoPago: function () {
                return this.recharge.payment === 'MPA';
            },
            isPicPay: function () {
                return this.recharge.payment === 'PIC';
            },

            showEstimateText: function () {
                return !this.isPeriodRecharge && !this.isAmountRecharge && this.estimate;
            },

            formattedAmountWithoutDecimal: function () {
                return this.amount ? Math.floor(this.amount).toFixed(0).replace('.', ',') : "";
            },
            formattedAmountDecimal: function () {
                return this.amount
                    ? this.amount.toFixed(2).slice(-2)
                    : (
                        this.recharge.amount
                            ? this.recharge.amount.toFixed(2).slice(-2)
                            : ""
                    );
            },

            btnRechargeText: function ()
            {
                const paymentAction = this.isOrderRecharge ? "Pagar" : "Recarregar";

                switch (this.recharge.payment)
                {
                    case "CRD": return `${paymentAction} com Cartão de Crédito`;
                    case "PIX": return `${paymentAction} com PIX`;
                    case "MPA": return `${paymentAction} com Mercado Pago`;
                    case "PIC": return `${paymentAction} com PicPay`;
                    case "BOL": return "Gerar Boleto";
                    default: return paymentAction;
                }
            },
            bonusValue: function ()
            {
                if (this.recharge.period <= 0) return 0;

                const bonusPct = this.bonusPercent[this.recharge.period];

                return ((this.monthlyCost * this.recharge.period) * bonusPct / 100);
            },
            noDiscountValue: function ()
            {
                if (!this.pricing) return 0;
                if (!this.isCheckout && (!this.user || !this.user.isNPT)) return 0;
                return Math.ceil(this.pricing[1] * this.recharge.period);
            },
            discountValue: function ()
            {
                if (!this.pricing) return 0;
                if (!this.isCheckout && (!this.user || !this.user.isNPT)) return 0;
                return this.noDiscountValue - Math.ceil(this.pricing[this.recharge.period] * this.recharge.period);
            },
            estimate: function ()
            {
                if (!this.monthlyCost) return "";

                const hourlyCost = this.monthlyCost / (30 * 24);
                const rechargeAmout = this.recharge.amount || 0;
                const totalHours = Math.floor(rechargeAmout / hourlyCost);

                const days = Math.floor(totalHours / 24);
                const hours = totalHours % 24;

                let message = "";

                if (days) {
                    message += days + " dias";

                    if (hours) {
                        message += " e ";
                    }
                }

                if (hours || (!hours && !days)) {
                    message += hours + " horas";
                }

                return message;
            },
        },
        created()
        {
            if (!this.isCheckout)
            {
                this.fetchUser();
                this.fetchPromotion();
            }
        },
        mounted()
        {
            if (this.email) {
                this.$set(this.recharge, 'email', this.email);
            }

            if (this.period) {
                this.$set(this.recharge, 'period', this.period);
            }

            const amount = this.amount || (
                this.showMonths && this.monthlyCost > 0
                    ? this.monthlyCost * this.recharge.period
                    : 50
                );

            this.$set(this.recharge, 'amount', amount);

            if (this.user) {
                this.userData = Object.assign({}, this.user);
                this.updateUserInfo();
            }

            // GA4 identifiers
            if (typeof window.gtag !== 'undefined' && typeof window.GA4_MEASUREMENT_ID !== 'undefined')
            {
                gtag('get', window.GA4_MEASUREMENT_ID, 'client_id', (clientID) => {
                    this.googleClientId = clientID;
                });

                gtag('get', window.GA4_MEASUREMENT_ID, 'session_id', (sessionID) => {
                    this.googleSessionId = sessionID;
                });
            }

            this.$refs.btnCreditCard.setLoading(true);
            this.initCreditCard();

            this.$nextTick(() => {
                if (this.isOrderRecharge || this.isAmountRecharge || !this.showMonths) {
                    this.$set(this.recharge, 'period', 0);
                }

                if (this.isOrderRecharge) {
                    this.$set(this.recharge, 'order', this.order);
                }

                if (!this.isOrderRecharge && !this.isAmountRecharge) {
                    this.fetchPricing();
                }
            });
        },
        methods: {
            ...mapActions({
                fetchUser: 'user/fetchUser',
                fetchPromotion: 'user/fetchPromotion',
                showErrorAlert: 'alert/error'
            }),

            fetchPricing()
            {
                this.$api.get(this.baseApiRoute + '/pricing')
                    .then(response => {
                        const pricing = response.data.data;

                        if (!pricing) return;

                        this.pricing = pricing;

                        const keys = Object.keys(this.pricing);
                        const periods = keys.filter(value => value != 1).map(value => parseInt(value));
                        this.discountPeriods = periods.sort((a,b) => a-b);

                        this._checkAmount();
                    })
                    .catch(error => this.showErrorAlert("Ocorreu um erro ao carregar os preços dos planos disponíveis."));
            },

            _forceManualAmount(amount)
            {
                this.recharge.period = 0;
                this.$set(this.recharge, 'amount', amount);
                this.$nextTick(() => { document.getElementById("rechargeAmount").focus() });
            },

            /**
             * Verificar se o valor de recarga está dentro dos limites permitidos.
             */
            _checkAmount()
            {
                if (this.isOrderRecharge) return;

                if (this.isPeriodRecharge)
                {
                    const isAmountByPeriod = this.isCheckout || (this.user && this.user.isNPT);
                    let newAmount = 50;


                    if (this.isCheckout || this.user)
                    {
                        if (isAmountByPeriod) {
                            if (this.pricing) {
                                newAmount = this.pricing[this.recharge.period] * this.recharge.period;
                            }
                        }
                        else {
                            newAmount = this.monthlyCost * this.recharge.period;
                        }
                    }

                    this.recharge.amount = newAmount;
                }

                if (parseInt(this.recharge.amount) < this.minRecharge) {
                    this.recharge.amount = this.minRecharge;
                    this.formErrors.amount = 'O valor mínimo para recarga com esta forma de pagamento é de '+ this.minRecharge +' reais.';
                }
                else if (parseInt(this.recharge.amount) > 5000 && !this.isPeriodRecharge) {
                    this.recharge.amount = 5000;
                    this.formErrors.amount = 'O valor máximo para recarga manual é de 5.000 reais.';
                }
                else {
                    this.formErrors.amount = "";
                }
            },

            /**
             * Incrementar valor da recarga.
             */
            _increaseAmount()
            {
                if (Number.isInteger(this.recharge.amount) && this.recharge.amount < 5000) {
                    this.recharge.amount++;
                    this.formErrors.amount = "";
                }
            },

            /**
             * Decrementar valor da recarga.
             */
            _decreaseAmount()
            {
                if (this.recharge.amount && Number.isInteger(this.recharge.amount) && this.recharge.amount > this.minRecharge) {
                    this.recharge.amount--;
                    this.formErrors.amount = "";
                }
            },

            /**
             * Atualizar campos do formulário com dados do usuário.
             */
            updateUserInfo()
            {
                this.isZipCodeDisabled = true;

                this.$nextTick(() =>
                {
                    // Geral
                    this.$set(this.recharge, 'name',    this.userData.name);
                    this.$set(this.recharge, 'cpf',     this.userData.cpf);
                    this.$set(this.recharge, 'cpfCnpj', this.userData.cpf);
                    this.$set(this.recharge, 'phone',   this.userData.phone);
                    this.$set(this.recharge, 'email',   this.userData.email);

                    // Cartão de crédito
                    this.$set(this.recharge, 'cardBirthDate', this.userData.birthDate);

                    // Endereço
                    const addressStreet = this.userData.addressStreet;
                    const addressNumber = this.userData.addressNumber;
                    const idxComma = addressStreet.lastIndexOf(",");

                    if (!addressNumber && idxComma >= 0)
                    {
                        this.$set(this.rechargeAddress, 'addressStreet', addressStreet.substr(0, idxComma));
                        this.$set(this.rechargeAddress, 'addressNumber', addressStreet.substr(idxComma + 1).trim());
                    }
                    else {
                        this.$set(this.rechargeAddress, 'addressStreet', addressStreet);
                        this.$set(this.rechargeAddress, 'addressNumber', addressNumber);
                    }

                    this.$set(this.rechargeAddress, 'addressZip',          this.userData.addressZip);
                    this.$set(this.rechargeAddress, 'addressNeighborhood', this.userData.addressNeighborhood);
                    this.$set(this.rechargeAddress, 'addressCity',         this.userData.addressCity);
                    this.$set(this.rechargeAddress, 'addressState',        this.userData.addressState);

                    this.disableCityStateFields = Boolean(this.userData.addressZip);

                    setTimeout(() => this.isZipCodeDisabled = false, 100);

                    // Update data on component
                    this.$refs.groupAddress.setData(this.rechargeAddress);
                })
            },

            /**
             * Inicializar configurações para o pagamento com cartão de crédito.
             */
            initCreditCard()
            {
                if (typeof window.tmx_profiling_started === 'undefined')
                {
                    this.fingerprint = this.$cookie.get('hos_cc_fp');

                    if (!this.fingerprint)
                    {
                        this.$api.get(this.baseApiRoute + '/fingerprint')
                            .then(response => {
                                this.fingerprint = response.data.data.identifier;
                                this.$cookie.set('hos_cc_fp', this.fingerprint, { expires: '48h' });
                                this.loadCieloScript(this.fingerprint);
                            })
                            .catch(error => {
                                this.$refs.btnCreditCard.setLoading(false);
                                this.$refs.btnCreditCard.setDisabled(true);
                                this.$refs.btnCreditCard.$el.innerHTML = 'Indisponível no momento';
                            });
                    }
                    else {
                        this.loadCieloScript(this.fingerprint);
                    }
                }
                else {
                    this.$refs.btnCreditCard.setLoading(false);
                }
            },

            /**
             * Carregar script da Cielo.
             */
            loadCieloScript(identifier)
            {
                const script = document.createElement('script');

                let src = process.env.VUE_APP_CIELO_JS;
                src += '?org_id=' + process.env.VUE_APP_CIELO_ORG_ID;
                src += '&session_id=' + process.env.VUE_APP_CIELO_MERCHANT_ID + identifier;

                script.onload = () => {
                    this.$refs.btnCreditCard.setLoading(false);
                };

                script.onerror = () => {
                    this.$refs.btnCreditCard.setLoading(false);
                };

                script.type  = 'text/javascript';
                script.src   = src;
                script.async = true;
                script.id    = 'js-cc-fingerprint';

                if (!document.getElementById('js-cc-fingerprint')) {
                    document.head.appendChild(script);
                }
            },

            /**
             * Validar cupom de desconto.
             */
            validateCoupon()
            {
                this.couponMessage = this.formErrors.coupon = '';

                if (!this.recharge.coupon) return;

                this.$refs.rechargeCoupon.disabled = true;
                this.$refs.btnValidateCoupon.loadingFocus();

                this.$api.post('/recharge/validate-coupon', { 'coupon': this.recharge.coupon })
                    .then (response => this.couponMessage = response.data.message)
                    .catch(error => ErrorService.handleFormError(error, this))
                    .then (() => {
                        this.$refs.rechargeCoupon.disabled = false;
                        this.$refs.btnValidateCoupon.setLoading(false);
                    });
            },

            /**
             * Atualizar dados de endereço a partir do CEP.
             * @param {Object} data
             */
            cardUpdateAddress(data)
            {
                if (data)
                {
                    this.$set(this.rechargeAddress, 'addressStreet',       data.street);
                    this.$set(this.rechargeAddress, 'addressComplement',   data.complement);
                    this.$set(this.rechargeAddress, 'addressNeighborhood', data.neighborhood);
                    this.$set(this.rechargeAddress, 'addressCity',         data.city);
                    this.$set(this.rechargeAddress, 'addressState',        data.state);
                    this.disableCityStateFields = true;
                }
                else
                {
                    this.$set(this.rechargeAddress, 'addressCity',  '');
                    this.$set(this.rechargeAddress, 'addressState', '');
                    this.disableCityStateFields = false;
                }
            },

            _initRecharge()
            {
                this.formErrors = {};
                this.couponMessage = "";

                this.recharge.googleClientId  = this.googleClientId;
                this.recharge.googleSessionId = this.googleSessionId;
            },

            /**
             * Realizar recarga.
             */
            onRecharge()
            {
                this._initRecharge();

                switch (this.recharge.payment)
                {
                    case "CRD": this.rechargeCreditCard();  break;
                    case "PIX": this.rechargePix();         break;
                    case "BOL": this.rechargeBoleto();      break;
                    default:
                        alert("Método de pagamento inválido!");
                }
            },

            /**
             * Realizar pagamento com boleto.
             */
            rechargeBoleto()
            {
                this._initRecharge();

                this.$refs.btnBoleto.loadingFocus();

                let postData = Object.assign({}, this.recharge, this.rechargeAddress);

                this.$api.post(this.baseApiRoute, postData)
                    .then(response => {
                        this.boletoRechargeLink = response.data.data.link;
                        this.isRechargeSuccess = true;
                        this.trackPurchase('boleto', this.recharge.amount, this.recharge.coupon);
                        this.$emit('recharged');
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnBoleto.setLoading(false);
                    });
            },

            /**
             * Realizar pagamento com cartão de crédito.
             */
            rechargeCreditCard()
            {
                this._initRecharge();

                this.$refs.btnCreditCard.loadingFocus();

                let postData = Object.assign({}, this.recharge, this.rechargeAddress);

                // Browser fingerprint
                postData.fingerprint = this.fingerprint;

                this.$api.post(this.baseApiRoute + '/validate-card', postData)
                    .then(response => {
                        return this.$api.post(this.baseApiRoute, postData);
                    })
                    .then(response => {
                        this.paymentInvoice = response.data.data.invoice;
                        this.paymentState = response.data.data.state;
                        this.isRechargeSuccess = true;

                        this.trackPurchase('credit-card', this.recharge.amount, this.recharge.coupon);
                        this.$emit('recharged');

                        this.checkPayment();
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnCreditCard.setLoading(false);
                    });
            },

            /**
             * Efetuar pagamento com PIX.
             * Realiza o checkout e exibe o QR Code para pagamento.
             */
            rechargePix()
            {
                this._initRecharge();
                this.$refs.btnRecharge.setLoadingAndFocus();

                let postData = Object.assign({}, this.recharge, this.rechargeAddress);

                this.$api.post(this.baseApiRoute, postData)
                    .then(response => {
                        this.pixCode = response.data.data.code;
                        this.pixQrCode = response.data.data.qrcode;
                        this.pixExpiration = response.data.data.expiration;
                        this.isRechargeSuccess = true;

                        this.paymentInvoice = response.data.data.invoice;
                        this.paymentState = response.data.data.state;

                        this.trackPurchase('pix', this.recharge.amount, this.recharge.coupon);
                        this.$emit('recharged');

                        this.checkPayment();
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnRecharge.setLoading(false);
                    });
            },

            /**
             * Efetuar pagamento com Mercado Pago.
             */
            rechargeMercadoPago()
            {
                this._initRecharge();

                this.$refs.btnMercadoPago.loadingFocus();

                let postData = Object.assign({}, this.recharge, this.rechargeAddress);

                this.$api.post(this.baseApiRoute, postData)
                    .then(response => {
                        this.mercadoPagoRechargeLink = response.data.data.link;
                        this.isRechargeSuccess = true;
                        this.trackPurchase('mercadopago', this.recharge.amount, this.recharge.coupon);
                        this.$emit('recharged');

                        // Redirecionamento
                        setTimeout(() => { window.location.href = this.mercadoPagoRechargeLink; }, 5000);
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnMercadoPago.setLoading(false);
                    });
            },

            checkPayment()
            {
                let postData = {
                    invoice: this.paymentInvoice,
                    state: this.paymentState
                };

                if (this.isCheckout) {
                    postData.email = this.recharge.email;
                }

                this.$api.post(this.baseApiRoute + '/status', postData)
                    .then((response) => {
                        const paymentStatus = response.data.data.status;

                        if (paymentStatus === "Paid") {
                            this.isPaymentConfirmed = true;
                            this.$eventBus.$emit("credits-recharged");
                        }
                        else if (paymentStatus === "Cancelled") {
                            this.isPaymentCancelled = true;
                        }
                        else {
                            setTimeout(this.checkPayment, 5000);
                        }
                    })
                    .catch(() => {
                        setTimeout(this.checkPayment, 10000);
                    });
            },

            /**
             * TODO: Melhorar função (evitar usar window.location)
             */
            resetRecharge()
            {
                window.location.href = '/payment/recharge';
            },

            copyPixCode()
            {
                this.$refs.pixCopyPaste.select();
                document.execCommand('copy');
            },

            checkManualValue(value)
            {
                if (value === "1") {
                    this.recharge.period = 0;
                    this.$nextTick(() => { document.getElementById("rechargeAmount").focus() });
                }
                else {
                    if (this.recharge.period <= 0) {
                        this.recharge.period = 12;
                    }
                }

                UserService.trackEvent({
                    "action"   : "click",
                    "category" : "recharge",
                    "label"    : "button_manual_value",
                    "value"    : value,
                });
            },

            calcDiscount(period)
            {
                return this.pricing
                    ? Math.floor(100 * ((this.pricing[1] - this.pricing[period]) / this.pricing[1]))
                    : 0;
            },

            onClickPeriod(event, value)
            {
                // Avoid event duplication
                if (event.target && event.target.tagName && event.target.tagName.toLowerCase() !== "label") return;

                UserService.trackEvent({
                    "action"   : "click",
                    "category" : "recharge",
                    "label"    : "button_period",
                    "value"    : value,
                });
            }
        },
        watch: {
            user: function (val) {
                if (!this.userData && val) {
                    this.userData = Object.assign({}, val);
                    this.updateUserInfo();
                }
                this._checkAmount();
            },
            email: function (val, old) {
                if (val && !old) {
                    this.recharge.email = val;
                }
            },
            order: function (val, old) {
                if (val && !old) {
                    this.recharge.order = val;
                }
            },
            amount: function (val, old) {
                if (val && val !== old) {
                    this._forceManualAmount(val)
                    this._checkAmount();
                }
            },
            period: function (val, old) {
                if (val && val !== old) {
                    this.recharge.period = val;
                    this._checkAmount();
                }
            },
            monthlyCost: function (val, old) {
                if (val !== old) {
                    if (!val || val <= 0) this.isManualValue = "1";
                    this._checkAmount();
                }
            },
            showMonths: function (val, old) {
                if (val === true && val !== old) {
                    this.recharge.period = 12;
                    this._checkAmount();
                }
            },
            'recharge.payment': function (val, old) {
                if (val !== old) {
                    this.formErrors = {};
                    this._checkAmount();
                }
            },
            'recharge.period': function (val, old) {
                if (val !== old && val > 0) {
                    this.isManualValue = "0";
                    this.formErrors = {};
                    this._checkAmount();
                }
            }
        }
    }
</script>

<style lang="stylus">
    .h-o-card-recharge
        .input-group-amount
            .input-group-prepend .input-group-text
                border-color darken($input-bg, 10%)
                background-color darken($input-bg, 10%)

            .input-group-append .input-group-text
                background-color $input-bg
                padding-left 0 !important

            .input-group-text
                padding-top calc(.75rem + 1px)
                padding-bottom calc(.75rem - 1px)
                font-size 1.125rem

            .form-control
                padding-top 1rem
                padding-bottom 1rem
                border-right 0
                border-color $input-bg
                box-shadow none
                height calc(1.5em + 1.5rem + 2px)
                font-size 1.125rem

                &:disabled + .input-group-append .input-group-text
                    background-color $gray-200

        .mercadopago-button
            display none
            visibility hidden
            opacity 0
</style>